import React, { useContext, useEffect } from 'react';
import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  notification,
  Row,
  Select,
} from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';

import {
  getUserGroupsAction,
  savePersonalDetailsAction,
} from '../../../actions/UserActions';
import UserContext from '../../layout/UserContext';
import checkPermission from '../../../components/Authorization/Util';

import '@ant-design/compatible/assets/index.css';

const { TextArea } = Input;
const { Option } = Select;

const PersonalInfo = ({ form }) => {
  const dispatch = useDispatch();

  const { currentUser, userGroups } = useSelector(store => ({
    currentUser: store.userReducer.currentUser,
    userGroups: store.userReducer.userGroups,
  }));

  useEffect(() => {
    dispatch(getUserGroupsAction());
  }, []);

  const handleSubmit = e => {
    e.preventDefault();

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        

        dispatch(savePersonalDetailsAction(values, currentUser.id));
        notification.success({
          message: 'Success',
          description: 'User details are successfully updated!',
        });
        // message.success('Personal Details are saved!');
      }
    });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  const { getFieldDecorator } = form;
  const value = useContext(UserContext);

  // const value = this.context;
  const disable = !checkPermission(value, 'user', 'write');
  return (
    <Card bordered={false}>
      <Row>
        <Col span={16} offset={2}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Form {...formItemLayout} onSubmit={handleSubmit}>
            <Form.Item label="Name">
              {getFieldDecorator('name', {
                initialValue:
                  currentUser && currentUser.name
                    ? currentUser.name
                    : undefined,
                rules: [
                  {
                    required: true,
                    message: 'Please input your name!',
                  },
                ],
              })(<Input />)}
            </Form.Item>
            <Form.Item label="E-mail">
              {getFieldDecorator('email', {
                initialValue:
                  currentUser && currentUser.email
                    ? currentUser.email
                    : undefined,
                rules: [
                  {
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                  {
                    required: true,
                    message: 'Please input your E-mail!',
                  },
                ],
              })(<Input />)}
            </Form.Item>
            <Form.Item label="User Group">
              {getFieldDecorator('userGroup', {
                initialValue:
                  currentUser && currentUser.userGroup
                    ? currentUser.userGroup.id
                    : undefined,
                rules: [
                  {
                    required: true,
                    message: 'Please select user group!',
                  },
                ],
              })(
                <Select
                  allowClear
                  showSearch
                  filterOption
                  optionFilterProp="children"
                  disabled={disable}
                >
                  {userGroups.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.value}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="Phone Number">
              {getFieldDecorator('phoneNumber', {
                initialValue:
                  currentUser && currentUser.phoneNumber
                    ? currentUser.phoneNumber
                    : undefined,
                rules: [],
              })(<Input />)}
            </Form.Item>
            <Form.Item label="Address">
              {getFieldDecorator('address', {
                rules: [],
                initialValue:
                  currentUser && currentUser.address
                    ? currentUser.address
                    : undefined,
              })(<TextArea rows={3} />)}
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Divider />
      <Row type="flex" justify="center">
        <Button type="primary" onClick={handleSubmit}>
          <CheckOutlined /> Save
        </Button>
      </Row>
    </Card>
  );
};
PersonalInfo.propTypes = {
  form: PropTypes.object,
  userGroups: PropTypes.array,
  getUserGroupsAction: PropTypes.func,
  currentUser: PropTypes.object,
  savePersonalDetailsAction: PropTypes.func,
};

PersonalInfo.contextType = UserContext;

const WrappedPersonalInfo = Form.create({ name: 'personalInfoForm' })(
  PersonalInfo,
);

function mapStateToProps({ userReducer }) {
  const { userGroups } = userReducer;
  return { userGroups };
}
export default connect(mapStateToProps, {
  getUserGroupsAction,
  savePersonalDetailsAction,
})(WrappedPersonalInfo);
